export default "__VITE_ASSET__CpZ9Y6j0__"